var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2937 3775 c-90 -32 -131 -121 -96 -212 6 -15 96 -115 202 -220 l191 -193 -879 0 c-835 0 -882 -1 -921 -19 -100 -45 -129 -160 -63 -245 47 -59 -22 -56 1191 -56 1093 0 1114 0 1146 20 35 22 68 69 77 111 16 72 5 86 -365 454 -193 192 -356 352 -363 356 -28 15 -84 17 -120 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463 2289 c-94 -19 -151 -110 -124 -198 8 -30 84 -110 356 -381 190 -190 355 -350 368 -357 30 -17 102 -16 136 2 41 21 79 70 87 111 14 78 -4 105 -209 312 l-191 192 874 0 c561 0 888 4 912 10 49 14 104 76 113 129 8 50 -24 123 -68 155 -28 21 -39 21 -1127 26 -605 3 -1112 2 -1127 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.448ab1aae00ed5373c636c3193332352.svg";
export { ForwardRef as ReactComponent };